import React, { useState, useEffect } from "react";
import { Tooltip, List, ListItem, ListItemText } from '@mui/material';
import { Form, Input, Select } from 'antd';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import GenericDropdown from '../../../../components/generic/genericDropdown';
import { SearchOutlined } from "@ant-design/icons";
import { backendGetRequest, backendGetRequestWithCache, backendPostWithoutRefresh } from "../../../../helpers/callBackend";
import { toPrice } from "../../../../helpers/stringFormat";
import moment from "moment";
import SftpFilesTab from "./sftpFilesTab";
import FormattedTabs from "../../../../components/generic/formattedTabs";
import ExternalConnectionsDrawer from "../externalConnectionsDrawer";
import ExternalConnectionsRowDropdown from "../tempComponents/externalConnections/rowDropdown";
import ExternalConnectionsDetailsTableDropdown from "../tempComponents/externalConnections/tableDropdown/detailsTableDropdown";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import DisabledByDefaultOutlinedIcon from '@mui/icons-material/DisabledByDefaultOutlined';
import TableWithLoadingWrapper from "../../../../components/generic/dataGrid";
import { getGridNumericOperators } from "@mui/x-data-grid";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import ManageConnectionHeader from "../../../../components/generic/arpariBoxes/ManageConnectionHeader";
import OuterBox from "../../../../components/generic/arpariBoxes/OuterBox";
import LoadingButton from "@mui/lab/LoadingButton";
import GenericModal from "../../../../components/buttons/genericModal";
import InstitutionReconnectItem from '../../reconnectAccounts/temporaryComponents/institutionReconnectItem';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import ConnectionManagementProtocolModal from "./connectionManagementProtocolModal";
import PermissionGate from "../../../../helpers/PermissionGate";
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

const ManageConnectionsDetails = () => {
    const institutionKey = window.location.pathname.split("details/")[1].split("#")[0];
    const [institutionName, setInstitutionName] = useState("");
    const [source, sourceGroupId] = institutionKey.split('-').map((s, index) => index === 0 ? s.toUpperCase() : s);
    const [connections, setConnections] = useState([]);
    const [allConnections, setAllConnections] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageCountExpected, setPageCountExpected] = useState(-1);
    const [pageCountReceived, setPageCountReceived] = useState(0);

    const [connectionGroups, setConnectionGroups] = useState([]);
    const [showConnectionGroups, setShowConnectionGroups] = useState([]);
    const [sourceGroups, setSourceGroups] = useState([]);
    const [showSourceGroups, setShowSourceGroups] = useState([]);
    const [loadingSourceGroups, setLoadingSourceGroups] = useState(true);
    const [sourceGroupPageCountExpected, setSourceGroupPageCountExpected] = useState(-1);
    const [sourceGroupPageCountReceived, setSourceGroupPageCountReceived] = useState(0);
    const [sourceGroupIsAssignedCount, setSourceGroupIsAssignedCount] = useState(0);
    const [sourceGroupStatusLiveCount, setSourceGroupStatusLiveCount] = useState(0);

    const [isAssignedCount, setIsAssignedCount] = useState(0);
    const [statusLiveCount, setStatusLiveCount] = useState(0);
    const [totalBalance, setTotalBalance] = useState(0);
    const [totalLiabilities, setTotalLiabilities] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedAccountData, setSelectedAccountData] = useState([]);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [filesLoading, setFilesLoading] = useState(true);
    const [fileCopyPages, setFileCopyPages] = useState(1);
    const [files, setFiles] = useState([]);

    const [flattenedTags, setFlattenedTags] = useState([]);
    const [flattenedTagsLoading, setFlattenedTagsLoading] = useState(true);
    const [flattenedTagsPageCountExpected, setFlattenedTagsPageCountExpected] = useState(0);
    const [flattenedTagsPageCountReceived, setFlattenedTagsPageCountReceived] = useState(-1);
    const [groups, setGroups] = useState([]);
    const [groupsLoading, setGroupsLoading] = useState(true);
    const [groupsPageCountExpected, setGroupsPageCountExpected] = useState(0);
    const [groupsPageCountReceived, setGroupsPageCountReceived] = useState(-1);

    const BA_TAG = 1;

    const [modalVisible, setModalVisible] = useState({});
    const [modalSubmitting, setModalSubmitting] = useState({});
    const [refreshSubmitting, setRefreshSubmitting] = useState({});
    const [userCompanyObjects, setUserCompanyObjects] = useState([]);
    const [ucsLoaded, setUcsLoaded] = useState(false);

    const handleShowModal = (id) => {
        setModalVisible((prev) => ({ ...prev, [id]: true }));
    };

    const handleRefreshSourceGroup = async (id) => {
        setRefreshSubmitting((prev) => ({ ...prev, [id]: true }));
        setConnections((prev) =>
            prev.filter((conn) => `${conn.source}${conn.source_group_id}` !== id)
        );
        await getSourceGroupsRefresh();
        setRefreshSubmitting((prev) => ({ ...prev, [id]: false }));
    };

    const handleSubmit = (rowId, values) => {
        setModalSubmitting((prev) => ({ ...prev, [rowId]: true }));
        backendPostWithoutRefresh(
            "/api/external-connections/settings/",
            {
                source: source,
                source_group_id: rowId.slice(2),
                maintainers: values.maintainers,
                connected_by: values.connected_by,
                connection_group_name: values.connection_group_name,
            }
        ).then((res) => {
            if (res?.data?.data) {
                setSourceGroups((prev) => {
                    return prev.map((sg) =>
                        `${sg.source}${sg.source_group_id}` !== rowId ? sg : res.data.data
                    );
                });
            }
            setModalSubmitting((prev) => ({ ...prev, [rowId]: false }));
            handleCancelModal(rowId);
        });
    };

    const handleCancelModal = (id) => {
        setModalVisible((prev) => ({ ...prev, [id]: false }));
    };

    useEffect(() => {
        backendGetRequest("/api/landlord/permissions/", {})
            .then((ucsObjects) => {
                if (ucsObjects.status == 200) {
                    setUserCompanyObjects(ucsObjects.data?.data);
                    setUcsLoaded(true);
                }
            });
    }, []);

    useEffect(() => {
        backendGetRequest("/api/generic-tag/group/", { params: { page_index: 0, group_type: BA_TAG } })
            .then((res) => {
                setGroupsPageCountExpected(res?.data?.total_pages);
                for (let i = 1; i <= res?.data?.total_pages; i++) {
                    backendGetRequestWithCache("api/generic-tag/group/", { params: { page_index: i, group_type: BA_TAG } },
                        (cachedResponse) => {
                            const cachedGroups = cachedResponse?.data?.generic_groups || [];
                            setGroups(prevState => {
                                const updatedGroups = [...prevState];
                                cachedGroups.forEach(group => {
                                    if (!updatedGroups.some(existingGroup => existingGroup.id === group.id)) {
                                        updatedGroups.push(group);
                                    }
                                });
                                return updatedGroups;
                            });
                        },
                        (nonCachedResponse) => {
                            const nonCachedGroups = nonCachedResponse?.data?.generic_groups || [];
                            setGroups(prevState => {
                                const updatedGroups = [...prevState];
                                nonCachedGroups.forEach(group => {
                                    const index = updatedGroups.findIndex(existingGroup => existingGroup.id === group.id);
                                    if (index !== -1) {
                                        updatedGroups[index] = group;
                                    } else {
                                        updatedGroups.push(group);
                                    }
                                });
                                return updatedGroups;
                            });
                            setGroupsPageCountReceived(prevState => prevState === -1 ? 1 : prevState + 1);
                        },
                        (err) => {
                            setGroupsPageCountExpected(prevState => prevState - 1);
                        }
                    );
                }
            });

        backendGetRequest("/api/generic-tag/", { params: { page_index: 0, group_type: BA_TAG } })
            .then((res) => {
                setFlattenedTagsPageCountExpected(res?.data?.total_pages);
                for (let i = 1; i <= res?.data?.total_pages; i++) {
                    backendGetRequestWithCache("api/generic-tag/", { params: { page_index: i, group_type: BA_TAG } },
                        (cachedResponse) => {
                            const cachedTags = cachedResponse?.data?.generic_tags || [];
                            setFlattenedTags(prevState => {
                                const updatedTags = [...prevState];
                                cachedTags.forEach(tag => {
                                    if (!updatedTags.some(existingTag => existingTag.id === tag.id)) {
                                        updatedTags.push(tag);
                                    }
                                });
                                return updatedTags;
                            });
                        },
                        (nonCachedResponse) => {
                            const nonCachedTags = nonCachedResponse?.data?.generic_tags || [];
                            setFlattenedTags(prevState => {
                                const updatedTags = [...prevState];
                                nonCachedTags.forEach(tag => {
                                    const index = updatedTags.findIndex(existingTag => existingTag.id === tag.id);
                                    if (index !== -1) {
                                        updatedTags[index] = tag;
                                    } else {
                                        updatedTags.push(tag);
                                    }
                                });
                                return updatedTags;
                            });
                            setFlattenedTagsPageCountReceived(prevState => prevState === -1 ? 1 : prevState + 1);
                        },
                        (err) => {
                            setFlattenedTagsPageCountExpected(prevState => prevState - 1);
                        }
                    );
                }
            });
    }, []);

    useEffect(() => {
        if (!flattenedTagsPageCountExpected) return;
        setFlattenedTagsLoading(flattenedTagsPageCountExpected > flattenedTagsPageCountReceived);
    }, [flattenedTagsPageCountExpected, flattenedTagsPageCountReceived]);

    useEffect(() => {
        if (!groupsPageCountExpected) return;
        setGroupsLoading(groupsPageCountExpected > groupsPageCountReceived);
    }, [groupsPageCountExpected, groupsPageCountReceived]);


    useEffect(() => {
        if (pageCountExpected === -1) return;
        setLoading(pageCountExpected > pageCountReceived);
    }, [pageCountExpected, pageCountReceived]);

    useEffect(() => {
        backendGetRequest(
            "/api/external-connections/",
            { params: { source: source, sourceGroupId: sourceGroupId, pageIndex: 0 } }
        ).then((res) => {
            setPageCountExpected(res.data?.total_pages);
            for (let i = 1; i <= res.data?.total_pages; i++) {
                backendGetRequestWithCache(
                    "/api/external-connections/",
                    { params: { source: source, sourceGroupId: sourceGroupId, pageIndex: i } },
                    (cachedResponse) => {
                        if (cachedResponse?.data) {
                            const newConnections = cachedResponse?.data?.data || [];
                            setConnections(prevState => {
                                const existingIds = new Set(prevState.map(item => item.id));
                                const filteredData = newConnections.filter(item => !existingIds.has(item.id));
                                return [...prevState, ...filteredData];
                            });
                            setAllConnections((prevState) => {
                                const existingIds = new Set(prevState.map((item) => item.id));
                                const filteredData = newConnections.filter((item) => !existingIds.has(item.id));
                                return [...prevState, ...filteredData];
                            });
                        }
                    },
                    (nonCachedResponse) => {
                        if (nonCachedResponse?.data) {
                            const newConnections = nonCachedResponse?.data?.data || [];
                            setConnections(prevState => {
                                const existingMap = new Map(prevState.map(item => [item.id, item]));
                                newConnections.forEach(newConnection => {
                                    existingMap.set(newConnection.id, newConnection);
                                });
                                return Array.from(existingMap.values());
                            });
                            setAllConnections((prevState) => {
                                const existingMap = new Map(prevState.map((item) => [item.id, item]));
                                newConnections.forEach((newConnection) => {
                                    existingMap.set(newConnection.id, newConnection);
                                });
                                return Array.from(existingMap.values());
                            });
                            setPageCountReceived(prevState => prevState + 1);
                        }
                    },
                    (error) => {
                        setPageCountExpected(prevState => prevState - 1);
                    }
                );

            }
        });
        if (source === "FI" || source === "PL" || source === "FT" || source === "CX")
            getSourceGroupsRefresh();
        if (source === "FT")
            fetchSourceGroupFiles();
        getSourceGroups();
    }, []);

    const fetchSourceGroupFiles = async () => {
        await saveSourceGroupFiles();
        getNextSourceGroupFilesPage();
    };

    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    useEffect(() => {
        setShowSourceGroups(sourceGroups);
    }, [sourceGroups]);

    useEffect(() => {
        if (!sourceGroups.length) return;
        setConnectionGroups(() => {
            const allConnectionGroups = sourceGroups.flatMap(sg => sg.connection_groups || []);
            const uniqueConnectionGroupsMap = new Map();
            allConnectionGroups.forEach(group => {
                uniqueConnectionGroupsMap.set(group.id, group);
            });
            return Array.from(uniqueConnectionGroupsMap.values());
        });
    }, [sourceGroups]);

    useEffect(() => {
        setShowConnectionGroups(connectionGroups);
    }, [connectionGroups]);

    useEffect(() => {
        if (!sourceGroups.length) return;


        const assigned = sourceGroups.filter(sg => sg.is_assigned).length;
        const liveStatus = sourceGroups.filter(sg => sg.api_connection_status_live).length;

        setSourceGroupIsAssignedCount(assigned);
        setSourceGroupStatusLiveCount(liveStatus);
    }, [sourceGroups]);

    useEffect(() => {
        if (!connections.length) return;

        const assigned = connections.filter(conn => conn.is_assigned).length;
        const liveStatus = connections.filter(conn => conn.api_connection_status_live).length;
        const assets = connections.reduce((acc, conn) => conn.last_current_balance > 0 ? acc + conn.last_current_balance : acc, 0);
        const liabilities = connections.reduce((acc, conn) => conn.last_current_balance < 0 ? acc + conn.last_current_balance : acc, 0);

        setInstitutionName(connections?.[0].institution_name);
        setIsAssignedCount(assigned);
        setStatusLiveCount(liveStatus);
        setTotalBalance(assets);
        setTotalLiabilities(liabilities)
    }, [connections]);

    const saveSourceGroupFiles = async () => {
        const sourceGroupFilesURL = "/api/sftp/file-copy/";
        const params = {
            pageIndex: 0,
            sourceGroupId: sourceGroupId,
        };
        try {
            const response = await backendGetRequest(sourceGroupFilesURL, { params: params }, "");
            setFileCopyPages(response?.data?.total_pages);
        } catch (error) {
            console.error(`Error fetching files for page 0:`, error);
        }
    };

    const getNextSourceGroupFilesPage = async (pageIndex = 1) => {
        setFilesLoading(true);
        const sourceGroupFilesURL = "/api/sftp/file-copy/";
        const params = {
            pageIndex: pageIndex,
            sourceGroupId: sourceGroupId,
        };
        try {
            const response = await backendGetRequest(sourceGroupFilesURL, { params: params }, "");
            setFiles((prevState) => [...prevState, ...response?.data?.data]);
            setFilesLoading(false);
        } catch (error) {
            console.error(`Error fetching files for page ${pageIndex}:`, error);
            setFilesLoading(false);
        }
    };

    const getSourceGroupsRefresh = async () => {
        const sourceGroupRefreshURL = "/api/external-connections/refresh-v2/";
        let params = { pageIndex: 0, source: source, sourceGroupId: sourceGroupId };

        try {
            const response = await backendGetRequest(sourceGroupRefreshURL, { params }, "");
            let totalPages = response?.data?.total_pages || 0;

            const requests = Array.from({ length: totalPages }, (_, i) => {
                let pageParams = { pageIndex: i + 1, source, sourceGroupId };

                return backendGetRequest(sourceGroupRefreshURL, { params: pageParams })
                    .then((res) => {
                        if (res?.data) {
                            const newSourceGroups = res?.data?.data || [];
                            setConnections(prevState => {
                                const existingMap = new Map(prevState.map(item => [item.id, item]));
                                newSourceGroups.forEach(newItem => {
                                    existingMap.set(newItem.id, newItem);
                                });
                                return Array.from(existingMap.values());
                            });
                        }
                    })
                    .catch(error => {
                        console.error(`Error fetching page ${i + 1}:`, error);
                    });
            });

            await Promise.all(requests);
        } catch (error) {
            console.error('Error fetching external connections:', error);
        }
    };

    useEffect(() => {
        if (sourceGroupPageCountExpected === -1) return;
        setLoadingSourceGroups(sourceGroupPageCountExpected > sourceGroupPageCountReceived);
    }, [sourceGroupPageCountExpected, sourceGroupPageCountReceived]);

    const getSourceGroups = async () => {
        const sourceGroupURL = "/api/external-connections/source-group/";
        let params = { pageIndex: 0, source: source, institutionId: sourceGroupId };

        try {
            const response = await backendGetRequest(sourceGroupURL, { params }, "");
            let totalPages = response?.data?.total_pages || 0;
            setSourceGroupPageCountExpected(totalPages);

            for (let i = 1; i <= totalPages; i++) {
                let params = { pageIndex: i, source: source, institutionId: sourceGroupId };

                try {
                    backendGetRequestWithCache(
                        sourceGroupURL,
                        { params },
                        (cachedResponse) => {
                            if (cachedResponse?.data) {
                                const newSourceGroups = cachedResponse?.data?.data || [];
                                setSourceGroups(prevState => {
                                    const existingIds = new Set(prevState.map(item => item.id));
                                    const validGroups = newSourceGroups.filter(group =>
                                        group.institution_id === `${source}${sourceGroupId}`
                                    );
                                    const updatedGroups = [...prevState];
                                    validGroups.forEach(newItem => {
                                        if (!existingIds.has(newItem.id)) {
                                            updatedGroups.push(newItem);
                                        }
                                    });
                                    return updatedGroups;
                                });
                            }
                        },
                        (nonCachedResponse) => {
                            if (nonCachedResponse?.data) {
                                const newSourceGroups = nonCachedResponse?.data?.data || [];
                                setSourceGroups(prevState => {
                                    const existingMap = new Map(prevState.map(item => [item.id, item]));
                                    const validGroups = newSourceGroups.filter(group =>
                                        group.institution_id === `${source}${sourceGroupId}`
                                    );
                                    validGroups.forEach(newItem => {
                                        existingMap.set(newItem.id, newItem);
                                    });
                                    return Array.from(existingMap.values());
                                });
                                setSourceGroupPageCountReceived(prevState => prevState + 1);
                            }
                        },
                        (error) => {
                            setSourceGroupPageCountExpected(prevState => prevState - 1);
                        }
                    );
                } catch (error) {
                    console.error(`Error fetching page ${i}:`, error);
                }
            }
        } catch (error) {
            console.error("Error fetching external connections:", error);
        }
    };

    const deleteFileCopy = (fileCopyId) => {
        setFiles(prevState => prevState.filter(file => file.id !== fileCopyId));
    };

    const onLinkToDashboardSuccess = (record) => {
        setConnections(prevState => {
            return prevState.map(acc => {
                if (acc.id === parseInt(record.id)) {
                    return {
                        ...acc,
                        is_assigned: true,
                        id: record.id,
                    };
                }
                return acc;
            });
        });
    }

    const onLinkToDashboardMultiSuccess = (records) => {
        setConnections(prevState => {
            return prevState.map(acc => {
                const isAssigned = records.some(record => acc.id === parseInt(record.source_account_id));
                if (isAssigned) {
                    return {
                        ...acc,
                        is_assigned: true,
                    };
                }
                return acc;
            });
        });
    }

    const onEditSFTPAccountSuccess = (record) => {
        setConnections(prevState => {
            return prevState.map(acc => {
                if (acc.id === record.id && acc.source == record.source) {
                    return {
                        ...record,
                        id: acc.id,
                    }
                }
                return acc;
            });
        });
    }

    function findDuplicateLast4s(data) {
        const countMap = {};
        data.forEach((row) => {
            const last4 = row.account_number_last_4;
            if (last4) {
                countMap[last4] = (countMap[last4] || 0) + 1;
            }
        });

        return Object.keys(countMap).filter((key) => countMap[key] > 1);
    }

    const duplicateLast4s = React.useMemo(() => findDuplicateLast4s(connections || []), [connections]);

    const columns = [
        {
            field: "description",
            headerName: "Account",
            flex: 2.5,
            sortable: true,
            sortComparator: (a, b) => a?.localeCompare(b),
            renderCell: (params) => (
                <Box display="flex" alignItems="center" height="100%">
                    <Typography>{params.row.description}</Typography>
                </Box>
            ),
        },
        {
            field: "account_number_last_4",
            headerName: "Last 4",
            flex: 2,
            sortable: true,
            filterOperators: [
                ...getGridNumericOperators()
                    .filter((operator) => [">", "<"].includes(operator.value))
                    .map((operator) => ({
                        ...operator,
                        label: operator.value === ">" ? "Last 4 Desc" : "Last 4 Asc",
                        getApplyFilterFn: (filterItem) => {
                            if (!filterItem.value) {
                                return null;
                            }
                            return operator.getApplyFilterFn(filterItem);
                        },
                    })),
            ],
            renderCell: (params) => {
                const isDuplicate = duplicateLast4s.includes(params.row.account_number_last_4);
                return (
                    <Box display="flex" alignItems="center" height="100%">
                        <Typography color="secondary" sx={{ ml: 1, fontWeight: 'light', fontStyle: 'italic' }}>
                            (...{params.row.account_number_last_4})
                        </Typography>
                        {isDuplicate && (
                            <WarningAmberOutlinedIcon color="warning" sx={{ ml: 0.5, fontSize: 22 }} />

                        )}
                    </Box>
                )
            }
        },
        {
            field: "beneficiary_name",
            headerName: "Entity",
            flex: 2,
            renderCell: (params) => (
                <Box display="flex" alignItems="center" height="100%">
                    {params.row.beneficiary_name && params.row.beneficiary_name !== "Unknown" ? (
                        <Typography>{params.row.beneficiary_name}</Typography>
                    ) : (
                        <Typography color="secondary" sx={{ fontWeight: 'light', fontStyle: 'italic' }}>
                            Unknown
                        </Typography>
                    )}
                </Box>
            ),
        },
        {
            field: "connection_group_name",
            headerName: "Connection Group",
            flex: 2,
            renderCell: (params) => (
                <Box display="flex" alignItems="center" height="100%">
                    {params.row.connection_group_name && params.row.connection_group_name !== "Unknown" ? (
                        <Typography>{params.row.connection_group_name}</Typography>
                    ) : (
                        <Typography color="secondary" sx={{ fontWeight: 'light', fontStyle: 'italic' }}>
                            Unknown
                        </Typography>
                    )}
                </Box>
            ),
        },
        {
            field: "is_assigned",
            headerName: "Assigned",
            flex: 1.5,
            sortable: false, // Since it's a boolean, sorting may not be needed
            renderCell: (params) => (
                <Box display="flex" alignItems="center" justifyContent="center" height="100%" >
                    {params.row.is_assigned ? (
                        <CheckBoxOutlinedIcon color="success" />
                    ) : (
                        <DisabledByDefaultOutlinedIcon color="error" />
                    )}
                </Box>
            ),
        },
        {
            field: "api_connection_status_live",
            headerName: "Status",
            flex: 1.5,
            renderCell: (params) => (
                <Box display="flex" alignItems="center" justifyContent="center" height="100%">
                    {params.row.api_connection_status_live ? (
                        <CheckBoxOutlinedIcon color="success" />
                    ) : (
                        <Tooltip title={`This connection was last live on ${params.row.api_last_connection_time?.split(',')[0]}`}>
                            <DisabledByDefaultOutlinedIcon color="error" />
                        </Tooltip>
                    )}
                </Box>
            ),
        },
        {
            field: "last_current_balance",
            headerName: "Balance",
            flex: 1.5,
            align: "right",
            sortable: true,
            sortComparator: (a, b) => a - b,
            renderCell: (params) => (
                <Box display="flex" alignItems="center" justifyContent="flex-end" height="100%">
                    <Typography>{toPrice(params.row.last_current_balance)}</Typography>
                </Box>
            ),
        },
        {
            field: "actions",
            headerName: "",
            flex: 0.1,
            align: "right",
            sortable: false,
            renderCell: (params) => (
                <PermissionGate requiredRole='dashboardEditor'>
                    <Box display="flex" alignItems="center" justifyContent="center" height="100%">
                        <ExternalConnectionsRowDropdown
                            record={params.row}
                            connections={connections}
                            setExternalConnections={setConnections}
                            onLinkToDashboardSuccess={() => onLinkToDashboardSuccess(params.row)}
                            onEditSFTPAccountSuccess={(record) => onEditSFTPAccountSuccess(record)}
                            groups={groups}
                            flattenedTags={flattenedTags}
                            flattenedTagsLoading={flattenedTagsLoading}
                            groupsLoading={groupsLoading}
                        />
                    </Box>
                </PermissionGate>
            ),
        },
    ];

    const connectionGroupColumns = [
        {
            field: "connection_group_name",
            headerName: "Group",
            flex: 1.5,
            sortable: true,
            renderCell: (params) => (
                <Box display="flex" alignItems="center" height="100%">
                    {params.row.settings?.connection_group_name ? (
                        <Typography>{params.row.settings?.connection_group_name}</Typography>
                    ) : (
                        <Typography
                            sx={{
                                fontStyle: 'italic',
                                color: 'secondary.500',
                            }}
                        >
                            Unknown
                        </Typography>
                    )}
                </Box>
            ),
        },
        {
            field: "connected_by",
            headerName: "Connected By",
            flex: 1.5,
            sortable: true,
            renderCell: (params) => {
                const externalConnectionSettings = params.row.settings;
                return (
                    <Box display="flex" alignItems="center" height="100%">
                        <Typography sx={{ color: !externalConnectionSettings?.connected_by ? "secondary.500" : "secondary", fontStyle: "italic" }}>
                            {externalConnectionSettings?.connected_by || 'N/A'}
                        </Typography>
                    </Box>
                );
            },
        },
        {
            field: "maintainers",
            headerName: "Maintainers",
            flex: 2,
            sortable: true,
            renderCell: (params) => {
                const externalConnectionSettings = params.row.settings;
                const maintainers = externalConnectionSettings?.maintainers || [];

                return (
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="left"
                        height="100%"
                        gap={1}
                    >
                        {maintainers.length > 0 ? (
                            <Tooltip
                                title={
                                    <List>
                                        {maintainers.map((maintainer) => (
                                            <ListItem key={maintainer.user_display_name}>
                                                <ListItemText primary={maintainer.user_display_name} />
                                            </ListItem>
                                        ))}
                                    </List>
                                }
                            >
                                <Typography color="primary">
                                    {maintainers.length} Maintainer{maintainers.length !== 1 ? 's' : ''}
                                </Typography>
                            </Tooltip>
                        ) : (
                            <Typography color="text.secondary">No Maintainers</Typography>
                        )}
                    </Box>
                );
            },
        },
        {
            field: "live_count",
            headerName: "Status",
            flex: 1.5,
            sortable: true,
            sortComparator: (a, b) => a - b,
            renderCell: (params) => (
                <Box display="flex" alignItems="center" height="100%">
                    <Typography>{params?.row?.live_count} / {params?.row?.connection_count}</Typography>
                    {params?.row?.live_count < params?.row?.connection_count &&
                        <InstitutionReconnectItem
                            institutionName={params.row?.reconnect?.institution_name}
                            reconnectURL={params.row?.reconnect?.reconnect_url}
                            source={params.row?.reconnect?.source}
                            sourceId={params.row?.reconnect?.source_id}
                            sourceAccountId={params.row?.reconnect?.source_account_id}
                            title={<div style={{ marginLeft: 10 }}> Reconnect <ArrowRightAltIcon /> </div>}
                        />}
                </Box>
            ),
        },
        {
            field: "actions",
            headerName: "",
            align: "right",
            sortable: false,
            renderCell: (params) => {
                const isVisible = modalVisible[params.row.id] || false;

                return (
                    <Box alignItems="right" justifyContent="center" height="100%" spacing={1}>
                        {false &&
                            <LoadingButton
                                htmlType="submit"
                                style={{ width: "100px" }}
                                disableElevation fullWidth size="small" type="submit" variant="outlined" color="secondary"
                                sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                                onClick={() => handleRefreshSourceGroup(params.row.id)}
                            >
                                Refresh
                            </LoadingButton>}

                        <GenericDropdown
                            dropdownItems={[
                                <GenericModal
                                    button={<span> Edit </span>}
                                    modalTitle={`Edit Connection settings for ${params.row.institution_name || "Connection Group"}`}
                                    visible={isVisible}
                                    showModal={() => handleShowModal(params.row.id)}
                                    handleCancelModal={() => handleCancelModal(params.row.id)}
                                    size="md"
                                    modalBody={
                                        <Form
                                            layout="vertical"
                                            initialValues={{
                                                connected_by: params.row.settings?.connected_by,
                                                maintainers: params.row.settings?.maintainers?.map(m => m.email) || [],
                                            }}
                                            onFinish={(values) => handleSubmit(params.row.id, values)}
                                        >
                                            <Form.Item
                                                name="connection_group_name"
                                                label="Group Name"
                                                placeholder={params.row.settings?.connection_group_name}
                                                initialValue={params.row.settings?.connection_group_name}
                                            >
                                                <Input
                                                    placeholder={params.row.settings?.connection_group_name}
                                                    initialValue={params.row.settings?.connection_group_name}
                                                />
                                            </Form.Item>

                                            <Form.Item
                                                name="connected_by"
                                                label="Connected By"
                                            >
                                                <Input
                                                    disabled={params.row.settings?.connected_by}
                                                    initialValue={params.row.settings?.connected_by}
                                                />
                                            </Form.Item>

                                            <Form.Item
                                                name="maintainers"
                                                label="Maintainers"
                                                rules={[{ required: true }]}
                                            >
                                                <Select
                                                    mode="multiple"
                                                    style={{ width: '100%' }}
                                                    optionLabelProp="label"
                                                >
                                                    {userCompanyObjects?.map((maintainer) => (
                                                        <Select.Option
                                                            loading={!ucsLoaded}
                                                            disabled={!ucsLoaded}
                                                            key={maintainer.email}
                                                            value={maintainer.email}
                                                            label={maintainer.user_display_name || maintainer.email}
                                                        >
                                                            <div>{maintainer.user_display_name || maintainer.email}</div>
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>

                                            <Form.Item>
                                                <LoadingButton
                                                    htmlType="submit"
                                                    style={{ width: "100px" }}
                                                    loading={modalSubmitting[params.row.id]} loadingPosition="start"
                                                    disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                                                    sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                                                >
                                                    Submit
                                                </LoadingButton>
                                            </Form.Item>
                                        </Form>
                                    }
                                />
                            ]}
                            trigger={["click"]}
                            renderButton={(onClick) => (
                                <IconButton size="small" onClick={onClick}>
                                    <MoreVertIcon fontSize="small" />
                                </IconButton>
                            )}
                        />
                    </Box>
                );
            },
        },
    ];

    const handleExpand = (expanded, record) => {
        if (expanded) {
            const sourceMap = {
                "FI": "Finicity",
                "PL": "Plaid",
                "FT": "SFTP",
                "ICS": "Related ICS Account",
                "MA": "Manual Account",
                "CX": "Custom API Account",
            }
            const selectedAccountData = [
                {
                    "label": "Last Refresh Time",
                    "value": `Last refreshed on ${moment(record.api_last_connection_time).format("YYYY-MM-DD")} at ${moment(record.api_last_connection_time).format("hh:mm A")}`
                },
                {
                    "label": "Source",
                    "value": `${sourceMap[record.source]} (Connection Group #${record.source_group_id} / Connection #${record.id})`
                },
                ...((record.status?.error_code && record.status?.note) ? [{
                    "label": "Status",
                    "value": `Error ${record.status.error_code}: ${record.status.note}`
                }] : [])
            ];
            setSelectedAccountData(selectedAccountData);
            setExpandedRowKeys([record.id]);
        } else {
            setExpandedRowKeys([]);
        }
    };

    const handleSearchAccounts = (e) => {
        const searchText = e.target.value.trim();

        if (searchText === "") {
            setConnections(allConnections); // Reset to full data
        } else {
            const filteredData = allConnections.filter((item) =>
                item.description.toLowerCase().includes(searchText.toLowerCase()) ||
                item.beneficiary_name.toLowerCase().includes(searchText.toLowerCase()) ||
                item.account_number_last_4.toLowerCase().includes(searchText.toLowerCase())
            );
            setConnections(filteredData);
        }
    };

    const expandableConfig = {
        expandedRowRender: (record) =>
            <ExternalConnectionsDrawer
                open={true}
                data={selectedAccountData}
            />,
        expandRowByClick: true,
        onExpand: handleExpand,
        expandedRowKeys: expandedRowKeys,
        expandIconColumnIndex: -1,
    };

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            const selectedAccounts = selectedRows
                .map((row) => {
                    return {
                        account: row.description,
                        bankId: row.id,
                        key: row.id,
                        source: row.source,
                        live: row.api_connection_status_live,
                        entityName: row.beneficiary_name,
                        institution: row.institution_name,
                        last4: row.account_number_last_4,
                        isAssigned: row.is_assigned,
                        sourceGroupId: row.source_group_id,
                    };
                })
            setSelectedRows(selectedAccounts);
        }
    };

    const plaidAccessTokenOnSuccess = (plaidAccountsResponse, type) => {
        let plaidAccounts = plaidAccountsResponse?.data?.plaid_accounts;
        setConnections((prevState) => {
            return [...(plaidAccounts || []), ...prevState];
        });
    };

    const handleRemove = (account) => {
        const newSelectedRows = selectedRows.filter((row) => row.key !== account.id);
        setSelectedRows(newSelectedRows);
    };

    const onDeleteConnectionsSuccess = (deletedConnections) => {
        setConnections(prevState => prevState.filter(externalConnection =>
            !deletedConnections.some(deletedConnection => {
                return externalConnection.id === deletedConnection.key
            })
        ));
    }

    const TransactionDrawerX = () => (
        <ExternalConnectionsDrawer
            open={true}
            data={selectedAccountData}
        />
    );

    const updateProtocolText = (newText) => {
        setSourceGroups(prevSourceGroups => {
            const updatedSourceGroups = [...prevSourceGroups];
            if (updatedSourceGroups.length > 0) {
                updatedSourceGroups[0] = {
                    ...updatedSourceGroups[0],
                    settings: {
                        ...updatedSourceGroups[0].settings,
                        description: newText
                    }
                };
            }
            return updatedSourceGroups;
        });
    };

    const filteredColumns = source === "FT"
        ? columns.filter((col) => col.field !== "connection_group_name")
        : columns;

    return (
        <OuterBox>
            <ManageConnectionHeader
                title={institutionName}
                totalHealthy={connections.filter(item => item.api_connection_status_live).length}
                total={connections.length}
                connectionHealthSuffix={" connections"}
                titleBoxExtra={<>
                    <Stack direction="row" spacing={3}>
                        <Stack key={"assets"} direction="column">
                            <Typography color="textDisabled">
                                {totalLiabilities < 0 ? "Assets" : 'Balance'}
                            </Typography>
                            <Typography variant="h1" color="primary">
                                {toPrice(totalBalance)}

                            </Typography>
                        </Stack>
                        {totalLiabilities < 0 &&
                            <Stack key={"liabilities"} direction="column">
                                <Typography sx={{ color: "secondary" }}>
                                    {"Liabilities"}
                                </Typography>
                                <Typography variant="h1">
                                    {toPrice(totalLiabilities, { negPrefix: '(', negSuffix: ')' })}
                                </Typography>
                            </Stack>
                        }
                    </Stack>

                    {source === "FT" && (
                        <ConnectionManagementProtocolModal
                            institutionName={institutionName}
                            sourceGroupId={sourceGroupId}
                            source={source}
                            protocolText={sourceGroups.length > 0 ? sourceGroups[0]?.settings?.description : ""}
                            setProtocolText={updateProtocolText}
                        />
                    )}   </>
                }
                actions={<ExternalConnectionsDetailsTableDropdown
                    institutionName={institutionName}
                    onDeleteConnectionsSuccess={onDeleteConnectionsSuccess}
                    plaidAccessTokenOnSuccess={plaidAccessTokenOnSuccess}
                    selectedRows={selectedRows}
                    handleRemove={handleRemove}
                    setExternalConnections={setConnections}
                    tableData={connections}
                    source={source}
                    sourceGroupId={sourceGroupId}
                    onLinkToDashboardSuccess={(res) => onLinkToDashboardMultiSuccess(res)}
                    onSFTPUploadSuccess={(files) => {
                        setFiles(prevState => [...prevState, ...files]);
                    }}
                />}
                stat1Title="Assigned"
                stat1={`${connections.filter(item => item.is_assigned).length} / ${connections.length}`}
                stat2Title="Live"
                stat2={`${connections.filter(item => item.api_connection_status_live).length} / ${connections.length}`}

            />
            {(activeTab === 0 || (activeTab === 1 && (source === "FI" || source === "PL"))) && ( // Show input only for "Accounts" or "Groups" tab
                <Input
                    disabled={loading}
                    placeholder="Search"
                    prefix={<SearchOutlined />}
                    onChange={activeTab === 1 ? handleSearchAccounts : null}
                />
            )}

            <Box sx={{ width: '100%' }}>
                <FormattedTabs
                    defaultActiveKey={activeTab}
                    onChange={(key) => handleTabChange(key)}
                    tabPanes={[
                        ...((source === "FI" || source === "PL")
                            ? [{
                                title: "Groups",
                                key: 0,
                                body: (
                                    <TableWithLoadingWrapper
                                        columns={connectionGroupColumns}
                                        dataSource={showConnectionGroups}
                                        rowKey={(connectionGroup) => connectionGroup.id}
                                        pagination={false}
                                        loading={loadingSourceGroups}
                                        numerator={sourceGroupPageCountReceived}
                                        denominator={sourceGroupPageCountExpected}
                                    />
                                ),
                            }]
                            : []
                        ),
                        {
                            title: "Accounts",
                            key: (source === "FI" || source === "PL") ? 1 : 0,
                            body: (
                                <>
                                    {/* Warning Box */}
                                    {duplicateLast4s.length > 0 && (
                                        <Box display="flex" alignItems="center" mb={2}>
                                            <WarningAmberOutlinedIcon color="warning" sx={{ mr: 1, fontSize: 22 }} />
                                            <Typography color="primary">
                                                There may be duplicate connections. Please check accounts ending {duplicateLast4s.join(", ")}.
                                            </Typography>
                                        </Box>
                                    )}
                                    <TableWithLoadingWrapper
                                        columns={filteredColumns}
                                        dataSource={connections}
                                        rowKey={(connection) => connection.id}
                                        pagination={false}
                                        loading={loading}
                                        enableExpandable={true}
                                        numerator={pageCountReceived}
                                        denominator={pageCountExpected}
                                        handleExpand={handleExpand}
                                        transactionDrawer={TransactionDrawerX}
                                        onRowClick={(rowData) => {
                                            if (handleExpand) {
                                                handleExpand(true, rowData);
                                            }
                                        }}
                                    />
                                </>
                            ),
                        },
                        ...(source === "FT"
                            ? [{
                                title: "Files",
                                key: 1,
                                body: (
                                    <SftpFilesTab
                                        files={files}
                                        loading={filesLoading}
                                        deleteFileCopy={deleteFileCopy}
                                        fileCopyPages={fileCopyPages}
                                        getNextSourceGroupFilesPage={getNextSourceGroupFilesPage}
                                    />
                                ),
                            }]
                            : []
                        ),
                    ]}
                />
            </Box>
        </OuterBox>
    );

}

export default ManageConnectionsDetails;
